{
  "list": {
    "title": "Connexion list",
    "subtitle": "Chronopost connexion list",
    "newLink": "Add connexion"
  },
  "create": {
    "title": "Create expressist transporter connexion",
    "subtitle": "Expressist transporter connexion creation form"
  },
  "update": {
    "title": "Edit expressist transporter connexion",
    "subtitle": "Expressist transporter connexion edit form"
  },
  "detail": {
    "title": "Connexion detail",
    "subtitle": "Transporter - {transporterName} / Connexion - {connexionName}",
    "transporterInformation": "Transporter information",
    "connexionInformation": "Connexion information",
    "linkInformation": "Link information"
  },
  "table": {
    "name": "Connexion",
    "type": "Connexion type",
    "service": "Service",
    "linkCount": "Link count"
  },
  "filters": {
    "operatingCenter": "Operating center"
  },
  "fields": {
    "transporterName": "Name",
    "transporterType": "Transporter type",
    "weight": "Max weight (kg)",
    "power": "Max power (wh)",
    "height": "Max height (mm)",
    "width": "Max width (mm)",
    "name": "Connexion",
    "connexionName": "Connexion name",
    "type": "Connexion type",
    "identifier": "Identifier",
    "password": "Password",
    "service": "Service(s)",
    "network": "Key-account network",
    "operatingCenter": "Operating center",
    "priority": "Use this link as priority",
    "repairCenterScopeMode": "Repair center mode",
    "repairCenterScopeModeAuto": "Automatic",
    "repairCenterScopeModeManual": "Manual",
    "repairCenterManualScopeLabel": "Configure repair centers manually",
    "repairCenterAllowedLabel": "Allowed repair centers",
    "linkPriorityLabel": "Use this link as priority"
  },
  "form": {
    "connexionTitle": "Connexion",
    "linkTitle": "Link"
  },
  "placeholders": {
    "connexionService": "Select connexion service",
    "connexionName": "Ex: Connexion name",
    "connexionType": "Select connexion type",
    "connexionIdentifier": "Ex: ID.TRANSPORT",
    "connexionPassword": "Enter connexion password",
    "keyAccountNetwork": "Select key-account network",
    "operatingCenter": "Select operating center",
    "repairCenterAllowed": "Select one or more allowed repair centers"
  },
  "actions": {
    "create": "Validate connexion creation",
    "update": "Validate connexion edit"
  },
  "search": "Search",
  "connexionTypes": {
    "OPERATING_CENTER": "Operating center"
  },
  "deleteModal": {
    "title": "Delete expressist connexion",
    "message": "Do you really want to delete connexion {connexion}?",
    "warning": "This action cannot be undone."
  },
  "messages": {
    "createSuccess": "Expressist connexion created successfully",
    "updateSuccess": "Expressist connexion updated successfully",
    "deleteSuccess": "Expressist connexion deleted successfully"
  }
}
